// extracted by mini-css-extract-plugin
export var currencyInput = "_ix-1";
export var currencySymbol = "_ix-0";